module.exports = __webpack_public_path__ + "front/img/33_6.edc81e22.png";